import React from "react";
import PickupWaitlist from "./PickupWaitlist";
import "./PickupPage.css";

/**
 * Full-site maintenance page — rendered instead of the whole app when
 * REACT_APP_SITE_MODE = "maintenance". Keeps the brand, collects a waitlist,
 * gives people an email address. Nothing else is reachable.
 */

const MaintenancePage: React.FC = () => (
  <div className="ee-maintenance">
    <img src="/logo-main.png" alt="Everything Eco NYC" className="ee-maintenance-logo" />
    <p className="ee-maintenance-tag">Brooklyn-born · Community powered · Getting ready</p>
    <PickupWaitlist />
    <p className="ee-maintenance-foot">© {new Date().getFullYear()} Everything Eco NYC · Williamsburg, Brooklyn</p>
  </div>
);

export default MaintenancePage;
